import React from 'react';
import { selectPeers, useHMSStore } from '@100mslive/react-sdk';
import { Box } from '@100mslive/roomkit-react';
import PracticeQuestion from './PracticeQuestion';
import { GridCenterView } from '../../gridView';
import PracticeMobileHeader from './PracticeMobileHeader';
import { useVoiceAssistant } from '@livekit/components-react';
const PracticeMobile = React.memo(({ form, handleEndCall, timer, practiceStatus = true, updateSocket }) => {
    const voiceAssistant = useVoiceAssistant();
    const peers = useHMSStore(selectPeers);
    const candidatePeer = peers.filter((peer) => peer.roleName === 'candidate');
    const viewportHeight = window.innerHeight;
    const calculateHeight = (value) => {
        const difference = viewportHeight - (viewportHeight * (100 - value)) / 100;
        return `${difference}px`;
    };

    return (
        <Box
            css={{
                w: '100%',
                flex: '1 1 0',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            id="conferencing"
            data-testid="conferencing"
        >
            <div
                style={{
                    height: calculateHeight(25),
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <PracticeMobileHeader handleEndCall={handleEndCall} form={form} timer={timer} />
            </div>
            <div style={{ height: calculateHeight(35) }}>
                <GridCenterView
                    peers={candidatePeer}
                    maxTileCount={1}
                    isMobile
                    form={form}
                    practiceStatus={practiceStatus}
                />
            </div>
            <div style={{ height: calculateHeight(40) }}>
                <PracticeQuestion
                    agentAudioTrack={voiceAssistant?.audioTrack}
                    practiceStatus={practiceStatus}
                    transcriptDetails={form?.transcriptDetails || ''}
                    updateSocket={updateSocket}
                />
            </div>
        </Box>
    );
});

export default PracticeMobile;
